import { el, List, list, RedomComponent } from "redom";
import { VideoListItemData } from "./videoListItemData";
import { LogHelpers } from "../../logHelper";
import { VideoListItemOptions } from "./videoListItemOptions";
import { S4yPopoverComponent } from "../../components/s4yPopoverComponent/s4yPopoverComponent";
import { disableWait, S4Y_GLOBAL, showWait } from "../../globalHelpers";
import { CommentListItemComponent } from "./comment-list-item-component/commentListItemComponent";
import { format } from "../../commonHelpers";
import { CommentListItemComponentData } from "./comment-list-item-component/commentListItemComponentData";

export class VideoListItem implements RedomComponent {
  private logHelper = new LogHelpers('VideoListItem');

  // HTML elements
  el: HTMLDivElement;
  holderElement: HTMLParagraphElement;
  titleElement: HTMLParagraphElement;
  thumbImageElement: HTMLImageElement;

  likeAnchorElement: HTMLAnchorElement;
  commentAnchorElement: HTMLAnchorElement;
  likeCountElement: HTMLSpanElement;

  commentListElement: List;

  // Component data modal
  data: VideoListItemData;
  commentList: CommentListItemComponentData[] = [];
  isAuthenticated = S4Y_GLOBAL.isAuthenticated;

  constructor(private options?: VideoListItemOptions) {
    this.logHelper.log(`Call constructor`);
    if (options) {
      this.logHelper.log(options);
    }
    this.el = el('div', { class: 's4y-masonry-brick' }, [
      this.thumbImageElement = el('img'),
      this.titleElement = el('p'),
      this.holderElement = el('p'),
      el('div', { class: 'video-actions' }, [
        this.likeAnchorElement = el('a', { href: '#' }, [
          el('img', {
            src: this.options.likeImageIconUrl,
          }),
          this.likeCountElement = el('span')
        ]),
        this.commentAnchorElement = el('a', { href: '#' }, [
          el('img', {
            src: this.options.commentImageIconUrl,
          }),
        ]),
      ])
    ]);
    this.likeButtonHandler();
    this.commentButtonHandler();
    this.playMediaHandler();
  }

  private playMediaHandler() {
    this.thumbImageElement.addEventListener('click', () => {
      if (this.data) {
        this.el.dispatchEvent(new CustomEvent('thumbnailClicked', {
          detail: {
            MEDIA_ID: this.data.MEDIA_ID
          },
          bubbles: true
        }));
      }
    });
  }

  private commentButtonHandler() {
    const commentPopover = new S4yPopoverComponent({
      dockElement: this.commentAnchorElement,
      trigger: 'manual'
    });

    if (this.isAuthenticated) {
      // Add comment textbox
      let postCommentFormElement: HTMLFormElement;
      commentPopover.el.appendChild(el('div', { class: 'video-comment-compose' }, [
        postCommentFormElement = el('form', [
          el('textarea', { class: 'd-form-control', name: "content" }),
          el('button', { type: 'submit', class: 'd-btn d-btn-light' }, [
            el('img', { src: this.options.postCommentButtonIconUrl })
          ])
        ]),
      ]));

      // post comment form submit event handler
      postCommentFormElement.addEventListener('submit', evt => {
        evt.preventDefault();
        const formData = new FormData(postCommentFormElement);
        formData.append('mediaId', this.data.MEDIA_ID.toString());

        // post data to the API
        showWait();
        fetch(this.options.postCommentUrl, {
          credentials: 'include',
          method: 'POST',
          body: formData
        }).then(resp => resp.json()).then(data => {
          disableWait();
          this.logHelper.log(data);
          // add new comment to the comment list
          this.commentList.push(data);
          // update comment list element
          this.commentListElement.update(this.commentList);
          // reset form
          postCommentFormElement.reset();
        }).catch(() => {
          disableWait();
        });
      });
    }

    // comment button event handler
    this.commentAnchorElement.addEventListener('click', (e) => {
      e.preventDefault();
      if (!commentPopover.popoverState.isShown) {
        // show the popover
        // Load comment list from remote via ajax
        const commentListUrl = typeof this.options.commentListUrl === 'string' ?
          this.options.commentListUrl : this.options.commentListUrl(this.data.MEDIA_ID);
        showWait();
        fetch(commentListUrl)
          .then(rep => rep.ok ? rep.json() : Promise.resolve([]))
          .then(data => {
            this.commentList = data;
            disableWait();

            // generate comment list element
            this.commentListElement = list(commentPopover.popoverBodyContentElement, CommentListItemComponent, "ID");
            this.commentListElement.update(data);
            commentPopover.toggle();
          });
      } else {
        commentPopover.toggle();
      }
    });
  }

  update?(item: VideoListItemData, index: number, data: any, context?: any): void {
    this.logHelper.log('Call update  method');
    if (item) {
      this.logHelper.log(item);
    }
    this.data = item;
    const link = 'https://videodelivery.net/' + item.MEDIA_UID + '/thumbnails/thumbnail.gif?height=140&duration=4s' + '&time=' + (item.DURATION - 4) + 's';
    const holder = '© ' + item.MEDIA_IPRHOLDER + ' ' + item.MEDIA_YEAR;
    const title = item.MEDIA_TITLE;
    const description = item.MEDIA_DESCRIPTION;
    this.holderElement.textContent = holder;
    this.titleElement.textContent = title;
    this.titleElement.setAttribute('title', description);
    if (this.thumbImageElement.src !== link) {
      this.thumbImageElement.src = link;
    }

    this.likeCountElement.textContent = item.LIKE_CNT ? item.LIKE_CNT.toString() : '';

    // Disable like button if need
    if (this.data.LIKE_STATUS !== 0 && this.data.LIKE_STATUS !== 1) {
      this.likeAnchorElement.classList.add('disabled');
    } else {
      this.likeAnchorElement.classList.remove('disabled');
    }
  }

  onmount?(): void {
  }

  onremount?(): void {
  }

  onunmount?(): void {
  }

  private postComment() {

  }

  private likeButtonHandler() {
    this.likeAnchorElement.addEventListener('click', (e) => {
      e.preventDefault();
      // check user logged in
      if (S4Y_GLOBAL.principalKey && typeof (+S4Y_GLOBAL.principalKey) === 'number' && +S4Y_GLOBAL.principalKey > 0) {
        if (this.data.LIKE_STATUS !== 0 && this.data.LIKE_STATUS !== 1) {
          // Can't like or un-like click
          this.logHelper.log(`LIKE_STATUS = ${this.data.LIKE_STATUS}. Can't like or un-like click`);
          return;
        }
        showWait();
        const likeUrl = format(this.options.likeUrl, [this.data.MEDIA_ID, this.data.LIKE_STATUS === 0 ? 1 : -1]);
        console.log(`Call LIKE api to like or unlike a media, MEDIA_ID=${this.data.MEDIA_ID}, likeUrl = ${likeUrl}`);
        fetch(likeUrl).then(rep => rep.json()).then(data => {
          disableWait();
          this.logHelper.log('TODO: check returned data to process UI');
          if (data.liked === 'screen.imagefeed.liked') {
            // successfully like
            this.data.LIKE_CNT++;
            this.data.LIKE_STATUS = 1;
            this.update(this.data, undefined, undefined);
          }
          if (data.unliked === 'screen.imagefeed.unliked') {
            this.data.LIKE_CNT--;
            this.data.LIKE_STATUS = 2;
            this.update(this.data, undefined, undefined);
          }
        }).catch(reason => {
          disableWait();
        });
      } else {
        // do nothing
        this.logHelper.log('anonymous users can\'t live a video');
      }
    });
  }
}